import { Avatar } from "@mui/material";
import { stringAvatar } from "../../../lib/utils/avatar-functions";
import { ClientEntityType } from "../../../../../lib/supabase/supabaseTypes";
import { useCentralStore } from "@/dentlab/src/store/Central";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import {
	getClientDisplayName,
	getClientFullName,
} from "@/lib/utils/client-utils";
import {
	CommandDialog,
	CommandEmpty,
	CommandGroup,
	CommandInput,
	CommandItem,
	CommandList,
} from "@lab/src/components/ui/command";

export const ClientList: React.FC<{
	onClick: (client: ClientEntityType) => void;
	open: boolean;
	setOpen: (open: boolean) => void;
	openForm: () => void;
}> = ({ onClick, open, setOpen, openForm }) => {
	const { clients } = useCentralStore((state) => ({
		clients: Object.values(state.clientsLookup).filter(
			(client: ClientEntityType) =>
				!client.is_inactive &&
				(client.connected_organization_id === null ||
					client.connected_organization_id === "")
		),
	}));

	return (
		<CommandDialog onOpenChange={setOpen} open={open}>
			<CommandInput placeholder="Kunden suchen…" />{" "}
			<CommandList className="w-full h-96 max-h-96">
				<CommandGroup heading="Aktionen">
					<CommandItem
						className="h-12 flex pl-5 gap-2 w-full items-center justify-start font-medium"
						onSelect={openForm}
					>
						<AddCircleIcon />
						<div className="text-sm font-medium">
							Kunden hinzufügen
						</div>
					</CommandItem>
				</CommandGroup>{" "}
				<CommandEmpty>Keine Kunden</CommandEmpty>
				<CommandGroup heading="Kunden auswählen" className="w-full">
					{clients.length > 0 ? (
						clients.map((client: ClientEntityType) => (
							<CommandItem
								onSelect={() => {
									onClick(client);
								}}
								key={client.id}
								className="h-12"
							>
								<ClientListRow client={client} />
							</CommandItem>
						))
					) : (
						<CommandItem className="h-12 flex items-center justify-center aria-selected:bg-transparent pointer-events-none">
							<div className="text-sm">
								Es gibt keine Kunden ohne bestehende Verbindung
							</div>
						</CommandItem>
					)}
				</CommandGroup>
			</CommandList>
		</CommandDialog>
	);
};

const ClientListRow: React.FC<{
	client: ClientEntityType & { image_src?: string };
}> = ({ client }) => {
	const { sx, children } = stringAvatar(getClientDisplayName(client));

	return (
		<div
			className="cursor-pointer flex flex-row w-full"
			data-testid="client-list-row"
		>
			<Avatar
				style={{
					borderRadius: "10px", // To match AppBarButton
				}}
				sx={{ width: "30px", height: "30px", fontSize: "16px", ...sx }}
				id={client.id ?? undefined}
			>
				{/* check if the client has a profile picture by seeing if the avatar_path exists and it has a url  */}
				{client.avatar_path &&
				client?.avatar_path?.split("/")[0] != "public" ? (
					<img
						src={client.image_src}
						alt="Client Avatar"
						style={{
							width: "100%",
							height: "100%",
							objectFit: "cover",
						}}
					/>
				) : (
					children
				)}
			</Avatar>
			<div className="flex flex-row items-center pl-2 w-full gap-1">
				<div className="text-sm font-medium">
					{getClientFullName(client)}
					{/* TODO: https://dentdesk.atlassian.net/browse/DW-895 */}
					<span
						style={{
							color: "grey",
							fontSize: "0.8rem",
						}}
					>
						{client.connected_organization_id &&
							"(mit dentCONNECT verbunden)"}
					</span>
				</div>
				<div className="text-sm">{client.code}</div>
			</div>
		</div>
	);
};
